import styled from 'styled-components';
import { Flex } from 'rebass';
import colors from '../../theme/colors';

const DropDownItemWrapper = styled(Flex)`
  align-items: center;
  color: ${props => (!props.disabled ? colors.primary : colors.darkGray)};
  display: flex;
  padding: ${props => (props.padding ? props.padding : '15px')};
  position: relative;
  text-align: left;
  width: 100%;
  z-index: 10;
  ${props =>
    !props.disabled &&
    `
      :hover {
        background: ${colors.lightGreen};
        color: ${colors.white};
        cursor: pointer;
        
        & path, & polygon {
          fill: ${colors.white};
        }
        
        & .DropDown__nested {
          visibility: inherit;
        }
      }
  `}
`;

export default DropDownItemWrapper;
